import isApiError from "@insite/client-framework/Common/isApiError";

export interface PdfResultModel {
    successful: boolean;
    result: false | Blob;
    errorMessage?: undefined;
    statusCode?: undefined;
}

export const url = "/api/v1/pdf/GetOrderAcknowledgement/";

export async function getOrderAcknowledgementPdf(orderNumber: string, isOrderHistoryDetailsPage: boolean) {
    const response = await fetch(`${url}${isOrderHistoryDetailsPage ? "" : "osn/"}${orderNumber}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return {
            successful: true,
            result: blob,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorMessage || error.errorJson.message || "Something went wrong!",
                statusCode: error.status,
            };
        }
        if (error.errorMessage) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: error.status,
            };
        }
        throw error;
    }
}
